module.exports = __webpack_public_path__ + "static/media/googlescholar.3ccc71b8.svg";